export const enum ELangKey {
  zh_cn = 'zh_cn', // 中文
  en = 'en'
}
